import { Button, Modal } from "antd";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ThreeDots from "./component/three_dots";
import OnboardContent from "./component/onboard_content";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setOnboardAlready } from "store/bailiff/onboard/onboard.action";
import { useSelector } from "react-redux";
import { onboardHasSelector } from "store/bailiff/onboard/onboard.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogOnboard = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const open = searchParams.get("viewOnboard") === "true";

  // -------------------------- STATE ---------------------------
  const [index, setIndex] = useState(0);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const onboard = useSelector(onboardHasSelector);
  console.log("onboard", onboard);
  // -------------------------- FUNCTION ------------------------
  const handleOffBoard = () => {
    setSearchParams({});
    if (!onboard) {
      dispatch(setOnboardAlready());
    }
  };

  const handleCancel = () => {
    setSearchParams({});
  };

  const handlePrev = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const handleNext = () => {
    if (index < 4) {
      setIndex(index + 1);
    }
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  const renderContent = () => {
    return <OnboardContent index={index} />;
  };

  const renderBottom = () => {
    return <ThreeDots setIndex={setIndex} index={index} />;
  };

  const renderSkip = () => {
    return (
      <Button
        className="absolute right-4 text-blue-700 underline hover:text-blue-800"
        size="large"
        type="link"
        onClick={handleOffBoard}
      >
        Bỏ qua
      </Button>
    );
  };

  const renderLeft = () => {
    return (
      <Button
        disabled={index === 0}
        className="absolute left-5"
        shape="circle"
        icon={<LeftOutlined />}
        onClick={handlePrev}
      />
    );
  };

  const renderRight = () => {
    return (
      <Button
        disabled={index === 4}
        onClick={handleNext}
        className="absolute right-5"
        shape="circle"
        icon={<RightOutlined />}
      />
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      centered
      onCancel={handleCancel}
      title={null}
      open={open}
      footer={null}
      closeIcon={null}
      closable={false}
      maskClosable={true}
    >
      <div className="flex min-h-[400px] flex-col justify-center">
        {renderLeft()}
        {renderRight()}
        <div className="flex-[0.9]">{renderContent()}</div>
        <div className="flex w-full flex-[0.1] flex-row items-center justify-center gap-2">
          {renderBottom()}
          {renderSkip()}
        </div>
      </div>
    </Modal>
  );
};
export default DialogOnboard;
